import { Component, Inject, OnInit } from "@angular/core";
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { map, scan, startWith } from "rxjs/operators";
import { Observable } from "rxjs";
import { ToastrService } from "ngx-toastr";

import { WINDOW } from "../../../../app.settings";
import { MonitorMenuDialogDessagesEnum } from "../../../../core/enums/toastr-messages/monitor-menu-dialog-messages.enum";
import { ScreenResolutions } from "../../../../core/enums/screen-resolution.enum";
import { RefreshRate } from "../../../../core/enums/refresh-rate-enum";
import { MachinesService } from "../../../../core/services/http-services/machines.service";
import { MonitorHub } from "../../../hubs/monitor.hub";
import { WindowPreviewInfo } from "../../../../core/models/entities/window-preview-info.model";
import { BehaviorScreen } from "../../../../core/models/view-models/monitor-models/screen.type";
import { AppConstants } from "../../../../app.constants";
import { MonitorsService } from "../../../../core/services/http-services/monitors.service";
import { ShareContentToPublicParams } from "../../../../core/models/entities/share-content-to-public-params.model";
import { UIService } from "../../../../core/services/utils/ui.service";
import { ScreensStateService } from "../../../../core/services/screen-state/screens-state.service";

@Component({
  selector: 'modal-full-screen-link-generator',
  templateUrl: './modal-full-screen-link-generator.component.html',
  styleUrls: ['./modal-full-screen-link-generator.component.scss']
})
export class ModalFullScreenLinkGeneratorComponent implements OnInit {
  screenLink: string;
  screenResolutions = ScreenResolutions;
  screenResolution = ScreenResolutions.Medium;
  refreshRates = RefreshRate;
  refreshRate = RefreshRate["1s"];
  windowsPreviewInfo$: Observable<WindowPreviewInfo[]>;
  selectedWindowPreview: WindowPreviewInfo;
  isPublicLink: boolean;
  private showScreenLabel: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) private monitor: BehaviorScreen,
    @Inject(WINDOW) private window: Window,
    private modalFullScreenLinkInstance: MatDialogRef<ModalFullScreenLinkGeneratorComponent>,
    private toastrService: ToastrService,
    private machineService: MachinesService,
    private monitorHub: MonitorHub,
    private monitorsService: MonitorsService,
    private uiService: UIService,
    private screenStateService: ScreensStateService
  ) {}

  ngOnInit(): void {
    this.machineService.getActiveWindows(this.monitor.MachinePhysicalAddress).subscribe();
    this.initShareContentValues();
    this.generateLink();
    this.getPublicParameter(this.getSelectedContentHandler());
  }

  closeModal() {
    this.modalFullScreenLinkInstance.close();
    this.toastrService.info(
      MonitorMenuDialogDessagesEnum.LinkCopiedToClipboardDescription, MonitorMenuDialogDessagesEnum.FullScreenViewTitle
    );
  }

  onToggleLabel(isChecked: boolean): void {
    this.showScreenLabel = isChecked;
    this.generateLink();
  }

  onResolutionChanged(value: string) {
    this.screenResolution = value;
    this.generateLink();
  }

  onRefreshRateChanged(value: number) {
    this.refreshRate = value;
    this.generateLink();
  }

  onSetPublicParameter(isChecked: boolean) {
    const params = new ShareContentToPublicParams(
      this.monitor.MachinePhysicalAddress,
      this.getSelectedContentHandler(),
      isChecked
    );

    this.monitorsService.setAnonymousParameter(params).subscribe();
  }

  onShareContentChanged() {
    this.generateLink();
    this.getPublicParameter(this.getSelectedContentHandler());
  }

  originalOrder(): number {
    return 0;
  }

  generateLink() {
    this.screenLink =
      `${this.window.location.href}${AppConstants.FULL_SCREEN_ROUTE}/` +
      `${this.monitor.MonitorHandler}:${this.monitor.MachinePhysicalAddress}/` +
      `${this.selectedWindowPreview.Handle?.value}/` +
      `${this.showScreenLabel}/` +
      `${this.screenResolution}/` +
      `${this.refreshRate}/`;
  }

  selectScreens() {
    this.screenStateService.unselectAll();
    this.uiService.shareContentLink.set({ link: this.screenLink, title: this.monitor.MonitorTitle });
    this.uiService.showBottomPanel();
    this.modalFullScreenLinkInstance.close();
  }

  private initShareContentValues() {
    this.selectedWindowPreview = new WindowPreviewInfo({ Image: this.monitor.PictureURL });

    this.windowsPreviewInfo$ = this.monitorHub.windowsPreviewInfo.pipe(
      startWith([this.selectedWindowPreview]),
      map((data, index) => index === 0
        ? data
        : data.map(window => ({...window, Image: `${AppConstants.BASE_64_IMAGE_FORMAT}, ${window.Image}`}))
      ),
      scan((acc, curr) => [...acc, ...curr])
    );
  }

  private getPublicParameter(handler: string) {
    this.monitorsService.getAnonymousParameter(this.monitor.MachinePhysicalAddress, handler).subscribe(
      isAllowed => this.isPublicLink = isAllowed
    );
  }

  private getSelectedContentHandler() {
    return this.selectedWindowPreview.Handle?.value
      ? this.selectedWindowPreview.Handle.value.toString()
      : this.monitor.MonitorHandler;
  }
}
